module.exports = __webpack_public_path__ + "img/quest_icon_0043_bag.f8308ca9.png";